import React from 'react';
import Add from '../icons/Add';
import { rgbaColor } from '../../utils/helpers';
// import './scss/index.scss';

const AddCardButton = ({ onClick, color, bgColor }) => {
    return (
        <div className="card-button-container">
            <button className="add-card-button" onClick={onClick} style={{ color: color }}>
                <Add size={18} color={color} />
                Add a card
            </button>
            <span className='card-icon full-deactivated'>
                <span className="material-symbols-outlined" style={{ color: color }}>
                    credit_card
                </span>
            </span>
        </div>
    );
}

export default AddCardButton;
